import React from 'react';
import * as ReactDOMClient from 'react-dom/client';
import { AppNames, LoginService } from 'ecarepd-shared-utilities';
import './index.css';
import App from './App';

// The following just need to be imported to start things
import './services/LocalizationService';
import './services/PdfService';

const KEY_TOKEN = 'hive-token';
const KEY_TOKEN_EXPIRATION = 'hive-token-expiration';
const KEY_USERNAME = 'hive-username';

LoginService.init({
  appName: AppNames.Patient,
  keyToken: KEY_TOKEN,
  keyTokenExpiration: KEY_TOKEN_EXPIRATION,
  keyUsername: KEY_USERNAME,
}).then(() => {
  const container = document.getElementById('root') as Element;
  const root = ReactDOMClient.createRoot(container);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
});
